import apiClient from '@/lib/axios'

export const createCheckoutSession = async (
  params: CreateCheckoutSessionParams
): Promise<CreateCheckoutSessionResponse> => {
  const response = await apiClient.post('/billing/create-checkout-session', {
    type: params.type,
  })

  return response.data
}

export const createBillingPortalSession = async (): Promise<CreateBillingSessionResponse> => {
  const response = await apiClient.post('/billing/create-billing-session')

  return response.data
}

export const requestEnterprisePlanUpgrade = async (
  params: RequestEnterprisePlanUpgradeParams
) => {
  const response = await apiClient.post(`/billing/send-enterprise-plan-request-email`, params)
  return response.data
}

export const addCreditsCheckout = async (
  params: AddCreditsCheckoutParams
) => {
  const response = await apiClient.post(`/billing/add-credits-checkout`, params)
  return response.data
}

export const getBillingInfo = async (): Promise<GetBillingInfoResponse> => {
  const response = await apiClient.get('/billing/info')
  return response.data
}

export const updateBillingInfo = async (params: UpdateBillingInfoParams) => {
  const response = await apiClient.patch('/billing/update-info', params)
  return response.data
}

export const getBillingHistory = async (): Promise<GetBillingHistoryResponse> => {
  const response = await apiClient.get('/billing/history')
  return response.data
}